export enum ActivityProgess {
  IN_PROGRESS = 'InProgress',
  COMPLETED = 'Completed',
}

export enum GradingProgress {
  FULLY_GRADED = 'FullyGraded',
  PENDING = 'Pending',
}

export interface GradeLtiPostRequest {
  score: number;
  activityProgress: ActivityProgess;
  gradingProgress: GradingProgress;
}

export type GradeLtiPostResponse = { score: boolean } | undefined;
